import { pageMeta } from '../seo.js';
import { Link } from 'react-router';
import ListView from '../components/ListView.jsx';
import { COMPANY_LIST, loadList } from '../data/list.js';
import { DateCell, StatusPill } from '../components/ui.jsx';
import { companyName, companyPath } from '../data/relations.js';
import { lifetime } from '../data/format.js';

// Each sortable column has an ORDERED index on :4902 (cvrweb CLAUDE.md, item 5).
const COLUMNS = [
  { key: 'name', label: 'Name', render: (c) => <Link to={companyPath(c)}>{companyName(c)}</Link> },
  // hideNarrow: an iPad in portrait and a phone do not show the CVR (owner 2026-09-26).
  { key: 'cvr', label: 'CVR', numeric: true, hideNarrow: true },
  { key: 'virksomhedsformkort', label: 'Form' },
  { key: 'sidstOpdateret', label: 'Opdateret', sortField: 'sidstOpdateret', render: (c) => <DateCell value={c.sidstOpdateret} /> },
  { key: 'stiftelsesDato', label: 'Stiftet', sortField: 'stiftelsesDato', render: (c) => <DateCell value={c.stiftelsesDato} /> },
  // hideNarrow: Levetid stays and shows the life of the company (owner 2026-09-26).
  { key: 'ophoersDato', label: 'Ophørt', sortField: 'ophoersDato', hideNarrow: true, render: (c) => <DateCell value={c.ophoersDato} /> },
  { key: 'levetid', label: 'Levetid', numeric: true, render: (c) => lifetime(c.stiftelsesDato, c.ophoersDato) },
  { key: 'cvrstatus', label: 'Status', sortField: 'cvrstatus', render: (c) => <StatusPill status={c.cvrstatus} /> },
];

// The checkboxes of filters.js. Without a search, a slow sort is dropped, and paging stops at row 1000.
const CHECKBOXES = [
  { key: 'reports', label: 'Only companies with annual reports' },
  { key: 'open', label: 'Hide closed companies' },
];

// The server gets the rows before it sends the page (data/list.js).
export const loader = ({ request }) => loadList(new URL(request.url), COMPANY_LIST);

// "/" and "/Companies" are the same page, so both name "/" as the canonical.
export const meta = () => pageMeta({
  title: 'Companies – CVR register',
  description: 'Search the Danish companies in the CVR register: name, CVR number, form, status and annual reports.',
  path: '/',
});

export default function CompaniesPage() {
  return (
    <ListView
      title="Companies"
      columns={COLUMNS}
      defaultSort={COMPANY_LIST.defaultSort}
      checkboxes={CHECKBOXES}
      placeholder="Company name, CVR number or JSON query"
      hint="A name search matches whole words: “jagt” does not find “jagtforening”."
    />
  );
}
